export const RECAPTCHA_CONTAINER_ID = 'g-recaptcha';
export const RECAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js?render=explicit';
